import React, { FC } from 'react';
import { useClsDivisionsQuery } from '../api';
import { Select } from '../components/Inputs';
import { ControllerProps } from 'react-hook-form/dist/types/props';

interface Divisions extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
  disabled?: boolean;
}

const Divisions: FC<Divisions> = ({ label, error, control, name, rules, disabled }) => {
  const { data } = useClsDivisionsQuery();
  return (
    <Select
      multiple
      label={label}
      data={(data && data.classifierValues) || []}
      control={control}
      error={error}
      name={name}
      rules={rules}
      disabled={disabled}
    />
  );
};

export default Divisions;
